import { h } from 'preact';

/**
 * OutOfStockOverlay - Displays overlay when product is unavailable
 *
 * **Features:**
 * - Shows "Currently Unavailable" message
 * - Styled with solid dark background and white text
 * - White overlay covers entire card to gray out everything
 * - Badge positioned at 25% from top of the card
 */
const OutOfStockOverlay = () => {
  return (
    <div className="absolute inset-0 z-30 pointer-events-none">
      {/* White overlay to gray out the entire card */}
      <div className="absolute inset-0 bg-white bg-opacity-50 z-20 pointer-events-none !block"></div>
      
      {/* Currently Unavailable badge - positioned at 25% from top */}
      <div className="absolute top-[25%] left-0 right-0 z-30 flex justify-center pointer-events-none">
        <div className="w-[90%] bg-[#585468] rounded-lg inline-flex justify-center items-center gap-1 h-9 shadow-lg">
          <div className="text-center justify-start text-white text-base font-medium font-inter-tight uppercase leading-[24px]">
            Currently Unavailable
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutOfStockOverlay; 